import { motion } from "motion/react";
import styles from "./Card.module.css";

export default function EmptyListCard() {
  return (
    <motion.div
      initial={{ opacity: [0.4, 1, 0.4] }}
      animate={{ opacity: [1, 0.4, 1] }}
      transition={{
        duration: 1,
        repeat: Infinity,
        ease: "linear"
      }}
      className={styles.listCard}
    >
      <div className={styles.listImage}>
        {/* <img className={styles.gridImageContent} src={imageURI as string} onLoad={handleImageLoad} /> */}
      </div>
      {/* <div className={styles.listPrice}>${formatPrice(Number(item.price_paid))}</div> */}
    </motion.div>
  );
}
